// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fo-a";
export var fulfillmentFormRail = "_fo-9";
export var headerTitleRow = "_fo-c";
export var orderDetailsWrapper = "_fo-7";
export var orderLinkTrigger = "_fo-2";
export var paymentInformationGrid = "_fo-h";
export var paymentSummaryColumn = "_fo-i";
export var shipmentContainer = "_fo-b";
export var shipmentDetailsMainPane = "_fo-8";
export var shipmentNavigationCard = "_fo-5";
export var shipmentNavigationRail = "_fo-3";
export var shipmentNavigationRailHeader = "_fo-4";
export var shipmentSummaryFact = "_fo-e";
export var shipmentSummaryGrid = "_fo-d";
export var shipmentSummaryMetadataRow = "_fo-f";
export var shipmentSummaryTags = "_fo-g";
export var shipmentWorkspace = "_fo-0";
export var shipmentWorkspaceContent = "_fo-6";
export var shipmentWorkspaceHeader = "_fo-1";